export default __webpack_public_path__ + "static/media/pic6.2a15254b.jpg";